export const bannerConfigs = [
    {
        conditionKey: 'showBogBanner',
        iconClass: 'fullslip__bog-icon',
        translationKey: 'racing.bog',
    },
    {
        conditionKey: 'showBoostedOddsBanner',
        iconClass: 'fullslip__boosted-odds-icon',
        translationKey: 'boosted_odds.title',
    },
    {
        conditionKey: 'showOddsBoostBanner',
        iconClass: 'fullslip__odds-boost-icon',
        translationKey: 'odds_boost.title',
    },
];
